import { IStyle, mergeStyles } from '@fluentui/react';
import { IH2OTheme, mediaDesktop, mediaNoDesktop, useClassNames, useHaicPageTitle, useTheme } from '@h2oai/ui-kit';

import { useEnv } from '../../utils/hooks';
import { ClassNamesFromIStyles } from '../../utils/models';
import { useWorkspaces } from '../Orchestrator/WorkspaceProvider';
import DashboardEventsWidget from './DashboardEventsWidget';
import DeploymentsWidget from './DeploymentsWidget';
import JobsChart from './JobsChart';
import NavigationWrapper from './NavigationWrapper';
import PageWrapper from './PageWrapper';
import { useGranularMLOpsPermissions } from './userActions';

interface IDashboardStyles {
  dasboard: IStyle;
  title: IStyle;
  widget: IStyle;
  widgetsRight: IStyle;
  eventsWidget: IStyle;
  widgetsContainer: IStyle;
  centerItems: IStyle;
  chartWrapper: IStyle;
  widgetsLeft: IStyle;
}

const dashboardStyles = (theme: IH2OTheme): IDashboardStyles => {
  return {
    dasboard: {
      display: 'flex',
      flexDirection: 'column',
      flexGrow: 1,
      padding: '10px 10px 20px 10px',
      margin: '0px 20px',
    },
    title: {
      color: theme.semanticColors?.textPrimary,
    },
    widget: {
      backgroundColor: theme.semanticColors?.contentBackground,
      padding: 20,
      borderWidth: 1,
      borderRadius: 4,
      borderStyle: 'solid',
      borderColor: theme.semanticColors?.inputBorder,
    },
    widgetsContainer: {
      display: 'flex',
      flexGrow: 1,
      width: '100%',
      ...mediaNoDesktop({
        flexWrap: 'wrap',
      }),
    },
    widgetsRight: {
      display: 'flex',
      flexDirection: 'column',
      ...mediaDesktop({
        width: 'calc(64% - 20px)',
      }),
      ...mediaNoDesktop({
        marginTop: 15,
        width: 'calc(100% - 20px)',
      }),
    },
    eventsWidget: {
      marginTop: 15,
      display: 'flex',
      flexGrow: 1,
    },
    widgetsLeft: {
      ...mediaDesktop({
        marginRight: 20,
        width: '36%',
        flexGrow: 1,
      }),
      ...mediaNoDesktop({
        width: 'calc(100% - 20px)',
      }),
      display: 'flex',
      flexDirection: 'column',
    },
    centerItems: {
      display: 'flex',
      flexDirection: 'column',
      flexGrow: 1,
      justifyContent: 'center',
    },
    chartWrapper: {
      marginBottom: 0,
    },
  };
};

const Dashboard = () => {
  const theme = useTheme(),
    env = useEnv(),
    classNames = useClassNames<IDashboardStyles, ClassNamesFromIStyles<IDashboardStyles>>(
      'dashboard',
      dashboardStyles(theme)
    ),
    { ACTIVE_WORKSPACE_NAME } = useWorkspaces(),
    permissions = useGranularMLOpsPermissions(ACTIVE_WORKSPACE_NAME);

  useHaicPageTitle('Home | MLOps', env?.cloudInstanceName);

  return (
    <NavigationWrapper>
      <PageWrapper>
        <div className={classNames.dasboard}>
          <h1 className={classNames.title}>Dashboard</h1>
          <div className={classNames.widgetsContainer}>
            {permissions.isAbleToViewDeploymentsDashboardWidget ? (
              <div className={mergeStyles(classNames.widget, classNames.widgetsLeft)}>
                <DeploymentsWidget />
              </div>
            ) : null}
            {permissions.isAbleToViewScroingDashboardWidget || permissions.isAbleToViewMLOpsEventsDashboardWidget ? (
              <div className={classNames.widgetsRight}>
                {permissions.isAbleToViewScroingDashboardWidget ? (
                  <div className={classNames.widget}>
                    <div className={classNames.chartWrapper}>
                      <JobsChart />
                    </div>
                  </div>
                ) : null}
                {permissions.isAbleToViewMLOpsEventsDashboardWidget ? (
                  <div className={mergeStyles(classNames.widget, classNames.eventsWidget)}>
                    <DashboardEventsWidget />
                  </div>
                ) : null}
              </div>
            ) : null}
          </div>
        </div>
      </PageWrapper>
    </NavigationWrapper>
  );
};

export default Dashboard;
